import { render, staticRenderFns } from "./Setting-Extract-Currency-Address.vue?vue&type=template&id=0eb55e5b&scoped=true&"
import script from "./Setting-Extract-Currency-Address.vue?vue&type=script&lang=js&"
export * from "./Setting-Extract-Currency-Address.vue?vue&type=script&lang=js&"
import style0 from "./Setting-Extract-Currency-Address.vue?vue&type=style&index=0&id=0eb55e5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb55e5b",
  null
  
)

export default component.exports